export const educationData = [
  {
    id: 1,
    institution: "Indian Institute of Information Technology (IIIT), Dharwad",
    course: "B.Tech.",
    startYear: "2018",
    endYear: "2022",
  },
  {
    id: 2,
    institution: "Saraswati Vidya Mandir, Orai",
    course: "Intermediate",
    startYear: "2014",
    endYear: "2016",
  },
  {
    id: 3,
    institution: "Vinayak Academy, Orai",
    course: "High School",
    startYear: "2012",
    endYear: "2014",
  },
];
